<template>
  <div class="songkran-game">
    <!-- Loading / Not eligible -->
    <div v-if="!canPlay && !gameStarted" class="songkran-message">
      <div class="msg-box">
        <div class="msg-emoji">🃏💦</div>
        <h2>จับคู่การ์ดสงกรานต์</h2>
        <p class="msg-text">{{ loadingText }}</p>
        <button v-if="showBackBtn" class="btn-back" @click="closeOrBack">กลับ</button>
      </div>
    </div>

    <!-- Start Screen -->
    <div v-if="canPlay && !gameStarted && !gameEnded" class="songkran-start">
      <div class="msg-box">
        <div class="msg-emoji">🃏💦</div>
        <h2>จับคู่การ์ดสงกรานต์</h2>
        <p class="msg-sub">เปิดการ์ดจับคู่ให้ครบ ยิ่งเร็วยิ่งได้คะแนนเยอะ!</p>
        <div class="user-row" v-if="pictureUrl">
          <img :src="pictureUrl" class="user-avatar" />
          <span class="user-name">{{ displayName }}</span>
        </div>
        <button class="btn-play" @click="startGame">🎮 เริ่มเล่น</button>
      </div>
    </div>

    <!-- Game Playing -->
    <div v-if="gameStarted && !gameEnded">
      <div class="game-ui-bar">
        <div class="ui-item"><span>🪙</span><span class="val-coin">{{ score }}</span></div>
        <div class="ui-item"><span>🔄</span><span class="val-moves">{{ moves }}</span></div>
        <div class="ui-item"><span>⏱️</span><span :class="{'val-warn': timeLeft <= 10}" class="val-time">{{ timeLeft }}</span></div>
      </div>
      <div class="game-wrap">
        <div class="card-grid">
          <div
            v-for="(card, index) in cards"
            :key="index"
            class="card"
            :class="{ flipped: card.flipped || card.matched, matched: card.matched }"
            @click="flipCard(index)"
          >
            <div class="card-face card-back"></div>
            <div class="card-face card-front">{{ card.emoji }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- End Screen -->
    <div v-if="gameEnded" class="songkran-end">
      <div class="msg-box">
        <div class="msg-emoji">{{ won ? '🎉' : '😢' }}</div>
        <div class="stars">
          <span v-for="i in 3" :key="i" :class="{ 'star-off': i > starCount }">⭐</span>
        </div>
        <h2>{{ won ? 'ยินดีด้วย!' : 'หมดเวลา!' }}</h2>
        <div class="result-box">
          <div class="result-label">คะแนนวันนี้</div>
          <div class="result-score">{{ score }}</div>
          <div class="result-stats">
            <div class="stat">เวลา<span>{{ timeUsed }}วิ</span></div>
            <div class="stat">เปิด<span>{{ moves }}ครั้ง</span></div>
            <div class="stat">แม่น<span>{{ accuracy }}%</span></div>
          </div>
        </div>
        <div v-if="resultTotal > 0" class="cumulative-box">
          <div class="cum-label">คะแนนสะสม (วันที่ {{ resultDays }}/5)</div>
          <div class="cum-score">{{ resultTotal.toLocaleString() }}</div>
        </div>
        <p v-if="saving" class="msg-sub">กำลังบันทึกคะแนน...</p>
        <div v-else class="end-buttons">
          <button class="btn-play" @click="goRanking">🏆 ดู Ranking</button>
          <button class="btn-back" @click="closeOrBack">ปิด</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/functions'
import router from './../router'
import liffService from '@/services/liff'
import moment from 'moment-timezone'

const ALL_EMOJIS = ['🔫','💦','🐘','🪣','🌺','🎯','🏮','☀️','🌈','🎶','🧊','🥥','🍉','🎪','🐠','🦋','🌻','🎵','🍧','🧃']

export default {
  name: 'SongkranMemory',
  data () {
    return {
      userKey: '',
      userId: '',
      userCode: '',
      displayName: '',
      pictureUrl: '',
      canPlay: false,
      showBackBtn: false,
      loadingText: 'กำลังตรวจสอบสิทธิ์...',
      gameStarted: false,
      gameEnded: false,
      won: false,
      saving: false,
      cards: [],
      flippedCards: [],
      matchedPairs: 0,
      totalPairs: 8,
      moves: 0,
      score: 0,
      timeLeft: 75,
      totalTime: 75,
      timeUsed: 0,
      accuracy: 0,
      starCount: 0,
      timer: null,
      canFlip: false,
      gameToken: null,
      resultTotal: 0,
      resultDays: 0
    }
  },
  mounted () {
    this.loadUserData()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    async loadUserData () {
      const profile = liffService.profile
      if (!profile) {
        this.loadingText = 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้'
        this.showBackBtn = true
        return
      }
      this.userId = profile.userId || ''
      this.displayName = profile.displayName || ''
      this.pictureUrl = profile.pictureUrl || ''
      if (!this.userId) {
        this.loadingText = 'กรุณาเข้าสู่ระบบ'
        this.showBackBtn = true
        return
      }
      const userSnap = await firebase.database().ref('/users').orderByChild('userId').equalTo(this.userId).once('value')
      const userData = userSnap.val()
      if (!userData) {
        this.loadingText = 'ไม่พบข้อมูลผู้ใช้ กรุณาสมัครสมาชิกก่อน'
        this.showBackBtn = true
        return
      }
      this.userKey = Object.keys(userData)[0]
      this.userCode = userData[this.userKey].code || ''
      await this.checkUserId()
    },

    async checkUserId () {
      try {
        const checkFn = firebase.app().functions('asia-east2').httpsCallable('checkSongkranEligibility')
        const result = await checkFn({ userkey: this.userKey })
        if (result.data.canPlay) {
          this.canPlay = true
        }
      } catch (err) {
        if (err.code === 'already-exists') {
          this.loadingText = 'คุณเริ่มเกมไปแล้ววันนี้ ไม่สามารถเริ่มใหม่ได้'
        } else if (err.code === 'failed-precondition') {
          this.loadingText = err.message || 'ยังไม่ถึงเวลาเล่นเกม (6-10 เมษายน)'
        } else {
          this.loadingText = 'เกิดข้อผิดพลาด กรุณาลองใหม่'
        }
        this.showBackBtn = true
      }
    },

    async requestToken () {
      try {
        const startFn = firebase.app().functions('asia-east2').httpsCallable('startSongkranGame')
        const result = await startFn({ userkey: this.userKey })
        if (result.data.canPlay) {
          this.gameToken = result.data.gameToken
          return true
        }
      } catch (err) {
        if (err.code === 'already-exists') {
          this.loadingText = 'คุณเริ่มเกมไปแล้ววันนี้ ไม่สามารถเริ่มใหม่ได้'
        } else {
          this.loadingText = 'เกิดข้อผิดพลาด กรุณาลองใหม่'
        }
        this.canPlay = false
        this.showBackBtn = true
      }
      return false
    },

    shuffle (arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    },

    async startGame () {
      const tokenOk = await this.requestToken()
      if (!tokenOk) return
      this.gameStarted = true
      this.gameEnded = false
      this.won = false
      this.score = 0
      this.moves = 0
      this.matchedPairs = 0
      this.timeLeft = this.totalTime
      this.flippedCards = []
      this.canFlip = false
      const emojis = this.shuffle([...ALL_EMOJIS]).slice(0, this.totalPairs)
      const deck = this.shuffle([...emojis, ...emojis])
      this.cards = deck.map(emoji => ({ emoji, flipped: false, matched: false }))
      setTimeout(() => {
        this.cards.forEach(c => { c.flipped = true })
        setTimeout(() => {
          this.cards.forEach(c => { c.flipped = false })
          this.canFlip = true
          this.startTimer()
        }, 1200)
      }, 300)
    },

    startTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.timeLeft--
        if (this.timeLeft <= 0) this.endGame(false)
      }, 1000)
    },

    flipCard (index) {
      if (!this.canFlip) return
      const card = this.cards[index]
      if (card.flipped || card.matched) return
      if (this.flippedCards.length >= 2) return
      this.$set(this.cards, index, { ...card, flipped: true })
      this.flippedCards.push(index)
      if (this.flippedCards.length === 2) {
        this.moves++
        this.canFlip = false
        const [a, b] = this.flippedCards
        if (this.cards[a].emoji === this.cards[b].emoji) {
          setTimeout(() => {
            this.$set(this.cards, a, { ...this.cards[a], matched: true })
            this.$set(this.cards, b, { ...this.cards[b], matched: true })
            this.matchedPairs++
            const timeBonus = Math.max(0, this.timeLeft * 2)
            const moveBonus = Math.max(0, 100 - this.moves * 3)
            this.score += 50 + timeBonus + moveBonus
            this.flippedCards = []
            this.canFlip = true
            if (this.matchedPairs >= this.totalPairs) this.endGame(true)
          }, 350)
        } else {
          setTimeout(() => {
            this.$set(this.cards, a, { ...this.cards[a], flipped: false })
            this.$set(this.cards, b, { ...this.cards[b], flipped: false })
            this.flippedCards = []
            this.canFlip = true
          }, 800)
        }
      }
    },

    async endGame (won) {
      clearInterval(this.timer)
      this.canFlip = false
      this.won = won
      this.timeUsed = this.totalTime - this.timeLeft
      this.accuracy = this.moves > 0 ? Math.round((this.matchedPairs / this.moves) * 100) : 0
      if (won) {
        this.score += this.timeLeft * 5
        if (this.accuracy >= 80) this.score += 200
        else if (this.accuracy >= 60) this.score += 100
      }
      this.starCount = 0
      if (won) {
        this.starCount = 1
        if (this.accuracy >= 50) this.starCount = 2
        if (this.accuracy >= 70) this.starCount = 3
      }
      this.gameEnded = true
      await this.submitScore()
    },

    async submitScore () {
      this.saving = true
      try {
        const submitFn = firebase.app().functions('asia-east2').httpsCallable('submitSongkranScore')
        const result = await submitFn({
          userkey: this.userKey, code: this.userCode,
          score: this.score, moves: this.moves, accuracy: this.accuracy,
          timeUsed: this.timeUsed, won: this.won, matchedPairs: this.matchedPairs,
          gameToken: this.gameToken
        })
        if (result.data.success) {
          this.resultTotal = result.data.totalScore
          this.resultDays = result.data.daysPlayed
        }
      } catch (err) {
        console.error('Submit score failed:', err)
      }
      this.saving = false
    },

    goRanking () { router.push('/songkran-ranking') },

    closeOrBack () {
      if (window.liff && window.liff.isInClient()) {
        window.liff.closeWindow()
      } else {
        router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.songkran-game { min-height: 100vh; background: linear-gradient(180deg, #0066cc 0%, #0099ff 50%, #33ccff 100%); }
.songkran-message, .songkran-start, .songkran-end { display:flex;align-items:center;justify-content:center;min-height:100vh;padding:20px; }
.msg-box { text-align:center;background:rgba(0,10,40,0.85);backdrop-filter:blur(12px);border-radius:24px;padding:30px 24px;max-width:400px;width:100%;border:2px solid rgba(255,255,255,0.1); }
.msg-emoji { font-size:60px;margin-bottom:12px; }
.msg-box h2 { color:#fff;font-size:22px;margin-bottom:8px; }
.msg-text { color:rgba(255,255,255,0.7);font-size:14px;margin-bottom:16px; }
.msg-sub { color:rgba(255,255,255,0.6);font-size:13px;margin-bottom:16px; }
.user-row { display:flex;align-items:center;justify-content:center;gap:10px;margin:16px 0; }
.user-avatar { width:36px;height:36px;border-radius:50%;border:2px solid rgba(255,255,255,0.3); }
.user-name { color:#fff;font-size:14px;font-weight:600; }
.btn-play { font-size:18px;font-weight:700;padding:12px 44px;border:none;border-radius:50px;background:linear-gradient(135deg,#FFD700,#FFA500);color:#333;cursor:pointer;box-shadow:0 4px 15px rgba(255,165,0,0.4); }
.btn-back { font-size:14px;font-weight:600;padding:8px 24px;margin-top:10px;border:1.5px solid rgba(255,255,255,0.3);border-radius:50px;background:rgba(255,255,255,0.08);color:#fff;cursor:pointer; }
.end-buttons { display:flex;flex-direction:column;align-items:center;gap:8px; }
.game-ui-bar { display:flex;justify-content:space-between;padding:10px 16px;background:rgba(0,0,0,0.5); }
.ui-item { display:flex;align-items:center;gap:6px;color:#fff;font-size:15px;font-weight:700; }
.val-coin { color:#FFD700;font-size:18px; }
.val-moves { color:#7FE0FF;font-size:18px; }
.val-time { color:#FF6B6B;font-size:18px; }
.val-warn { color:#FF4444;animation:pulse 0.5s ease infinite; }
@keyframes pulse { 0%,100%{transform:scale(1)} 50%{transform:scale(1.15)} }
.game-wrap { max-width:420px;margin:0 auto;padding:16px 12px; }
.card-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:10px;perspective:800px; }
.card { aspect-ratio:1;cursor:pointer;position:relative;transform-style:preserve-3d;transition:transform 0.5s cubic-bezier(0.4,0,0.2,1);border-radius:14px; }
.card.flipped { transform:rotateY(180deg); }
.card.matched .card-front { box-shadow:0 0 20px rgba(0,255,100,0.6);border-color:rgba(0,255,100,0.5); }
.card-face { position:absolute;inset:0;border-radius:14px;backface-visibility:hidden;display:flex;align-items:center;justify-content:center;border:2.5px solid rgba(255,255,255,0.25); }
.card-back { background:linear-gradient(135deg,#1a5cb0,#0d7fd4,#1a5cb0);box-shadow:0 4px 15px rgba(0,0,0,0.3); }
.card-back::before { content:'💧';font-size:32px;opacity:0.5; }
.card-front { background:linear-gradient(135deg,#fff,#e8f4ff);transform:rotateY(180deg);font-size:44px; }
.result-box { background:rgba(255,255,255,0.08);border-radius:16px;padding:16px;margin:12px 0;border:1.5px solid rgba(255,255,255,0.1); }
.result-label { font-size:13px;color:rgba(255,255,255,0.6); }
.result-score { font-size:42px;font-weight:900;color:#FFD700;text-shadow:0 0 12px rgba(255,215,0,0.4); }
.result-stats { display:flex;gap:14px;margin-top:8px;justify-content:center; }
.stat { font-size:11px;color:rgba(255,255,255,0.5);text-align:center; }
.stat span { display:block;font-size:16px;font-weight:700;color:#fff; }
.stars { font-size:32px;letter-spacing:6px;margin-bottom:6px; }
.star-off { opacity:0.3; }
.cumulative-box { background:linear-gradient(135deg,rgba(0,200,255,0.12),rgba(0,100,255,0.08));border:1.5px solid rgba(0,200,255,0.25);border-radius:14px;padding:10px 16px;margin-top:10px; }
.cum-label { font-size:12px;color:rgba(255,255,255,0.5); }
.cum-score { font-size:26px;font-weight:900;color:#00e0ff; }
</style>
